const safeParseAsJson = (str) => {
    try {
        return JSON.parse(str);
    } catch (e) {
        return null;
    }
};

const getGraphqlData = (str) => {
    const graphqlData = safeParseAsJson(str);

    if (!graphqlData) {
        console.error('Cannot parse graphqlData as JSON');
    }
    return graphqlData;
};

export {safeParseAsJson, getGraphqlData};
